import { unref, type ComponentPublicInstance, type Ref } from 'vue';

export type ElementOrComponent =
    | ComponentPublicInstance
    | HTMLElement
    | Ref<ComponentPublicInstance | null>
    | Ref<HTMLElement | null>
    | null;

/**
 * Converts an ElementOrComponent to a basic HTMLElement.
 *
 * If this is a component it needs to have a single root node ( TODO: Fix this so it can live with several children)
 * @param element The ElementOrComponent instance we want to reduce to a HTMLElement
 */
export const elementOrComponentToElement = (element: ElementOrComponent) => {
    const unrefed = unref(element);
    if (!unrefed) {
        return null;
    }
    return (unrefed instanceof HTMLElement ? unrefed : (unrefed as ComponentPublicInstance).$el) as HTMLElement;
};
